import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppConfigService {

  constructor(private http: HttpClient) { }

  public load(): any  {
    if (sessionStorage.hasOwnProperty('appconfig')) {
    }
    else {
      return new Promise((resolve, reject) => {
        this.http
          .get("assets/config/appconfig.json")
          .pipe( 
            map(data => {
              sessionStorage.setItem('appconfig', JSON.stringify(data))
            }),
            catchError(error => {
              resolve(error);
              return throwError("JSON error");
            })
          )
          .subscribe(firstResponse => {
            resolve(true);
          });
      });
    }
  }
}
